"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const slides = [
  {
    id: 1,
    title: "Download Vant for business today",
    bgImage: "/assets/bg.jpg",
    image: "./assets/businessMobile.png",
    linkAndoid: "https://play.google.com/store/apps/details?id=com.vantapp.vantbussiness",
    linkIos: "https://apps.apple.com/app/vant-business/id6744277881"
  },
  {
    id: 2,
    title:
      "Download Vant app today and start your journey towards financial freedom.",
    bgImage: "/assets/bg.jpg",
    image: "./assets/vPersonal.png",
    linkAndoid: "https://play.google.com/store/apps/details?id=com.vant.app",
    linkIos: "https://apps.apple.com/ng/app/vant-app/id6464392721"
  },
];

const Carousel = () => {
  return (
    <div className="relative">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        // pagination={false}
        className="rounded-4xl"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="relative rounded-[36px] md:rounded-[48px]"
              style={{
                backgroundImage: `url('${slide.bgImage}')`,
                backgroundPosition: "center 100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#142528",
              }}
            >
              <div className="flex flex-col lg:flex-row">
                <div className="flex-1 px-10 py-8 md:py-10 lg:p-20">
                  <p className="text-center lg:text-start text-lg md:text-2xl lg:text-2xl xl:text-4xl text-white font-bold leading-snug tracking-wider font-inter">
                    {slide.title}
                  </p>
                  <div className="flex justify-center lg:justify-start mt-2 md:mt-5 gap-4">
                    <a
                      href={slide.linkAndoid}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={"./assets/goggle.svg"}
                        className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] lg:h-[50px]"
                        alt="playstore_img"
                      />
                    </a>

                    <a
                      href={slide.linkIos}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={"./assets/app.svg"}
                        className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] lg:h-[50px]"
                        alt="appstore_img"
                      />
                    </a>
                  </div>
                </div>
                <div className="flex-1 lg:pt-10 flex justify-center">
                  <img
                    src={slide.image}
                    className="h-[200px] md:h-[280px]   lg:h-[360px]  object-contain"
                    alt="iphone_img"
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom pagination outside */}
      <div className="custom-pagination flex justify-center gap-2 mt-8"></div>
    </div>
  );
};

export default Carousel;
